function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable key-spacing */
import React from 'react';
import Select from 'react-select';
import VTRecurringType from '@engine/features/virtual_terminal/vt_recurring_type';
import { connect } from 'react-redux';

var RecurringType = /*#__PURE__*/function (_React$Component) {
  _inherits(RecurringType, _React$Component);

  var _super = _createSuper(RecurringType);

  function RecurringType(props) {
    var _this;

    _classCallCheck(this, RecurringType);

    _this = _super.call(this, props);

    _this.onChange = function (selecedOption) {
      var isSubsequent = selecedOption.value === 'subsequent';

      if (selecedOption !== _this.state.value) {
        _this.setState({
          value: selecedOption,
          isSubsequent: isSubsequent
        });

        VTRecurringType.onChange(isSubsequent, _this.features);
      }
    };

    _this.state = {
      isSubsequent: false,
      value: ''
    };
    return _this;
  }

  _createClass(RecurringType, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.terminalId !== this.props.terminalId) {
        VTRecurringType.onChange(this.state.isSubsequent, this.features);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          options = _this$props.options,
          recurring_type = _this$props.recurring_type;

      if (recurring_type) {
        var currentOption = options.find(function (option) {
          return option.value === recurring_type;
        });
        var isSubsequent = currentOption.value === 'subsequent';
        this.setState({
          value: currentOption,
          isSubsequent: isSubsequent
        });
      }
    }
  }, {
    key: "options",
    get: function get() {
      return this.props.options;
    }
  }, {
    key: "features",
    get: function get() {
      return {
        travel: this.props.travel,
        shipping_address: this.props.shipping_address,
        split_payments: this.props.split_payments,
        recurring_without_reference: this.props.recurring_without_reference,
        subsequent_recurring: this.props.subsequent_recurring
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.terminalId) {
        return null;
      }

      return React.createElement("div", {
        className: "form-group credit-card-payment-type"
      }, React.createElement("label", {
        htmlFor: "".concat(this.props.transactionType, "_transaction_recurring_type"),
        className: "control-label col-lg-4"
      }, I18n.t('object.attributes.recurring_type')), React.createElement("div", {
        className: "col-lg-6"
      }, React.createElement(Select, {
        id: "".concat(this.props.transactionType, "_transaction_recurring_type"),
        name: "".concat(this.props.transactionType, "_transaction[recurring_type]"),
        options: this.options,
        value: this.state.value,
        placeholder: I18n.t('actions.default.please_select'),
        onChange: function onChange(option) {
          return _this2.onChange(option);
        }
      })));
    }
  }]);

  return RecurringType;
}(React.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var virtualTerminalFormData = _ref.virtualTerminalFormData;
  return {
    terminalId: virtualTerminalFormData.terminalId,
    transactionType: virtualTerminalFormData.transactionType,
    travel: virtualTerminalFormData.travel,
    split_payments: virtualTerminalFormData.split_payments,
    shipping_address: virtualTerminalFormData.shipping_address,
    recurring_without_reference: virtualTerminalFormData.recurring_without_reference,
    subsequent_recurring: virtualTerminalFormData.subsequent_recurring
  };
};

export default connect(mapStateToProps, {})(RecurringType);